import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  color: ${COLORS.secondarySemiDark};
  margin: 0 auto;
  margin-top: 100px;
  max-width: 300px;
`
